module.exports = __webpack_public_path__ + "img/icon_1.ab8af6ca.png";